import {
  Accounting_Account_Type,
  useBasicDataQuery,
} from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import { useInvoiceStore } from "../store";

export const useFetchBasicData = () => {
  const store = useInvoiceStore();
  const { loading } = useBasicDataQuery({
    variables: {
      type: Accounting_Account_Type.Invoice,
    },
    onCompleted(data) {
      if (data) {
        store.setDependencies(data);
      }
    },
    ...onError(),
  });
  store.setClientsUsersVatRatesLoading(loading);
};
